<template>
	<div class="container-fluid bg-white">
		<toolbar>
			<h2>
				<i class="fa fa-wrench"></i>
				Services
			</h2>

			<projects-toolbar-controls
				:show-search="false"
				:show-new='true'
				:show-quote="true"
				:is-services="true"
				:action-items="[
					{link: '/service/new/details',text: 'New Service', icon:'fa-plus'},
					{link: '/service/new-quote/details',text: 'New Quote', icon:'fa-plus'},
				]"
				:mobile-breakpoint="mobileBreakpoint"
				v-on:newClick="newService">

				<div v-if="!showSearch" class="filter-select mt-1 mr-4">
					<i class="fa fa-search" style="font-size: 1.5em;" v-on:click="showSearch = true"></i>
				</div>

				<service-search-bar
					class="filter-tabs mr-2"
					:panel-hovers="true"
					v-on:searchSubmit="searchServices"
					v-on:clearSearch="clearSearch"
					v-on:filterChange="filterServices">
				</service-search-bar>

			</projects-toolbar-controls>
		</toolbar>

		<service-search-bar
			v-if="showSearch"
			class="filter-select mt-2 mb-4"
			v-on:searchSubmit="searchServices"
			v-on:clearSearch="clearSearch"
			v-on:filterChange="filterServices">
		</service-search-bar>

		<!-------------- This is where we start doing the stuff for service requests --------------->
		<div v-if="$store.serviceFilterArchiveValue == 'requests'">

			<div class="filter-controls">

				<div class="inline-field filter-tabs">
					<field :params="{type:'btn-group',buttons:filterButtonsArchive,tabStyling:true,disableNull:true}"
							 v-model="$store.serviceFilterArchiveValue"
							 v-on:change="statusToggled">
					</field>
				</div>

				<div class='filter-select'>
					<field
						label="Filter"
						col-class="col-2"
						v-model="$store.serviceFilterArchiveValue"
						v-on:change="statusToggled"
						:params="{type:'select',options:filterButtonsArchive}">
					</field>
				</div>

				<template v-if="getUserRoleType() == 'Admin' || ($store.JobPersonnelRole && $store.JobPersonnelRole.has_customer_requests)">

					<div class="d-flex flex-wrap justify-content-start mt-4 mx-5">

						<field
							label="Status"
							class="mb-3 mr-4"
							col-class="col-auto"
							v-model="requestStatusFilter"
							v-on:change="fetchServiceRequests"
							:params="{
								type:'btn-group',
								buttons: [
									{ text: 'New',		 		value: 'new' },
									{ text: 'Accepted', 		value: 'accepted' },
									{ text: 'Rejected', 		value: 'rejected' },
									{ text: 'Any Status',	value: 'all' },
								],
								disableNull:true }">
						</field>

						<field
							label="Search a Customer"
							class="mb-3"
							col-class="col-auto"
							v-model="requestCustomerFilter"
							:params="{type:'text'}">
						</field>

					</div>


					<table-list
						class="px-5"
						:records="mutatedServiceRequests"
						:fields="[
							{ label: 'Created At', 		key: 'createdAt' },
							{ label: 'Requested By', 	key: 'requestedBy' },
							{ label: 'Site Address', 	key: 'siteAddress' },
							{ label: 'Status', 			key: 'status' }
						]"
						:has-edit="true"
						edit-button-text="View"
						edit-button-icon="fa-eye"
						v-on:edit="openRequestModal"
						:mobile-breakpoint="$store.tableListMobileBreakpoint"
						record-name="Service Request"
						:hide-record-count="false"
						:clickable-row="false"
						:sortable="true"
						:total-paginated-records="mutatedServiceRequests.length">
					</table-list>

					<modal-dialog
						:modal-visible="requestModal.isVisible"
						v-on:closeModal="requestModal.isVisible = false"
						modal-size="modal-lg"
						title="Service Request"
						:submit-visible="false">

						<div v-if="requestModal.request" class="container px-4">

							<div class="row mt-2">
								<strong class="col-4">Request Status</strong>
								<span class="col-8">
									{{requestModal.request.status}}
									<template v-if="requestModal.request.status == 'Accepted' && 'Service' in requestModal.request">
										(
										<router-link :to="'/service/'+requestModal.request.Service.slug+'/dashboard'" title="Services">
											View Service
										</router-link>
										)
									</template>
								</span>
							</div>

							<div v-if="requestModal.request.is_rejected == '1'" class="row mt-2">
								<strong class="col-4">Rejection Reason</strong>
								<span class="col-8">
									{{requestModal.request.rejection_reason}}
								</span>
							</div>

							<div class="row mt-2">
								<strong class="col-4">Requested By</strong>
								<span class="col-8">{{requestModal.request.requestedBy}}</span>
							</div>
							<div class="row mt-2">
								<strong class="col-4">Requested At</strong>
								<span class="col-8">{{requestModal.request.createdAt}}</span>
							</div>
							<div class="row mt-2">
								<strong class="col-4">Site Address</strong>
								<span class="col-8">{{requestModal.request.fullAddress}}</span>
							</div>
							<div class="row mt-2">
								<strong class="col-4">Service Description</strong>
								<span class="col-8">{{requestModal.request.description}}</span>
							</div>
							<div class="row mt-2" v-if="'UploadFile' in requestModal.request && requestModal.request.UploadFile && requestModal.request.UploadFile.length">
								<strong class="col-4">Attachments</strong>
								<span class="col-8">
									<div v-for="(file, index) in requestModal.request.UploadFile">
										({{index + 1}}) <a download :href="file.src">{{file.original_filename}}</a>
									</div>
								</span>
							</div>

							<template v-if="requestModal.request.status == 'New'">
								<div v-if="!requestModal.confirmVisible" class="row mt-2 no-gutters justify-content-end">
									<button class="btn btn-danger mr-3" v-on:click="toggleConfirmRequest(true, false)">Reject</button>
									<button class="btn btn-primary" v-on:click="toggleConfirmRequest(true, true)">Accept</button>
								</div>

								<div v-else class="alert mt-4" :class="requestModal.willAccept ? 'alert-success d-flex justify-content-between flex-wrap' : 'alert-warning'">

									<span>
										Are you sure you would like to <strong>{{requestModal.willAccept ? 'accept' : 'reject'}}</strong> this service request?
									</span>

									<div v-if="!requestModal.willAccept" class="my-3">
										You may also include a reason for rejection:
										<textarea class="form-control" v-model="requestModal.rejectionText"></textarea>
									</div>

									<div v-if="!requestModal.disableConfirm" class="d-flex justify-content-end">
										<span class="mr-5" style="cursor:pointer" v-on:click="toggleConfirmRequest(false)">
											<i class="fa fa-times"></i>
										</span>

										<span style="cursor:pointer" v-on:click="respondRequest">
											<i class="fa fa-check"></i>
										</span>
									</div>

								</div>

							</template>

						</div>

					</modal-dialog>
				</template>

			</div>


		</div>

		<template v-else>

			<div class="d-flex justify-content-between">
				<field
					:params="{type:'boolean',doubleLabels:[
					'List View',
					'Schedule View'
				]}"
					v-model="calendarView"
					v-on:change="calendarViewChange"
					style="margin-bottom: 10px;">
				</field>

				<div>
					<button v-if="!mapExpanded" class="btn btn-light" v-on:click="mapExpanded = true" style="position: relative;top: -1px">
						<i class="fa fa-map"></i>
						Show Map
					</button>
				</div>

			</div>

			<div v-if="!calendarView" :class="{'message-panel-open':hasMessagePanel}">

				<div class="main-panel-container row" :class="{'message-panel-open':hasMessagePanel}">
					<div :class="{
						'col-lg-8' : mapExpanded,
						'col-lg-12' : !mapExpanded
						/*
						'main-expanded':!mapExpanded && hasModulePermRead('Services'),
						'main-shrunk':mapExpanded && hasModulePermRead('Services'),
						'main-full': !hasModulePermRead('Services')
						*/
					}" style="min-height: 700px;">

						<div v-if="hasModulePermRead('Services')" class="filter-controls">

							<div class="inline-field filter-tabs">
								<field :params="{type:'btn-group',buttons:filterButtonsArchive,tabStyling:true,disableNull:true}"
									v-model="$store.serviceFilterArchiveValue"
									:disabled="disableFilterTabs"
									v-on:change="statusToggled">
								</field>
							</div>

							<div class='filter-select'>
								<field
									label="Filter"
									col-class="col-2"
									v-model="$store.serviceFilterArchiveValue"
									v-on:change="statusToggled"
									:params="{type:'select',options:filterButtonsArchive}">
								</field>
							</div>

							<div v-if="$store.serviceFilterArchiveValue == 'archived'" class="inline-field">
								<field 
									:params="{
										type:'btn-group',
										buttons:filterButtonsYear,
										tabStyling:true,
										disableNull:true
									}" 
									:disabled="disableFilterTabs"
									v-model="$store.serviceFilterYearValue" 
									v-on:change="statusToggled">
								</field>
							</div>

						</div>

						<alert v-if="archiveWarningVisible" classes="alert-warning" :visible="archiveWarningVisible" icon="fa-info" v-on:close="archiveWarningVisible = false">
							Archiving services you don't need to see anymore will improve system performance
						</alert>

						<alert v-if="slowSystemWarningVisible" classes="alert-danger" :visible="archiveWarningVisible" icon="fa-info" :unclosable="true">
							<strong>List loading slowly?</strong>
							<div>You have an excessive number of services in your list -- archiving services that you don't need anymore will greatly improve performance.</div>
						</alert>

						<div v-if="calendarView" class="calendar-wrapper mb-2">

							<div class="d-flex align-items-center mb-2">
								<div>
									<button v-if="hasModulePermRead('Services')"
										:disabled="isFilterButtonDisabled"
										class="btn btn-light filter-button mr-1"
										v-on:click="filterButtonClick">

										<i class="fa fa-filter"></i>
										Filter
									</button>

									<button class="btn btn-light mr-1" v-on:click="calendarView = false">
										<i class="fa fa-list"></i>
										List View
									</button>
								</div>

								<div class="info-boxes">
									<info-box label="Service Jobs In Progress" :value="numServiceJobsInProgress" class="mr-1" :dark="true" title="The number of service jobs with at least one worker currently clocked into"></info-box>
									<info-box label="Service Jobs Found" :value="servicesCount" class="mr-1" :dark="true"></info-box>
									<info-box v-if="this.$store.serviceFilterArchiveValue == 'mine' || this.$store.serviceFilterArchiveValue == 'active'" label="Estimated Total Hours" :value="estimatedHours.toFixed(2)" class="mr-1" :dark="true"></info-box>
								</div>
							</div>

							<calendar :events="myServiceEvents"></calendar>
						</div>

						<div v-if="myListFilterPanelVisible && $store.serviceFilterArchiveValue == 'mine'" class="p-2 bg-light">
							<div class="d-flex justify-content-between">
								<h5>Filter My List</h5>

								<i class="fa fa-times icon-button" v-on:click="myListFilterPanelVisible = false"></i>
							</div>
							<div class="d-flex flex-wrap">
								<field
									label="Filter by Status"
									col-class="col-auto"
									class="mr-2"
									v-model="myListStatusFilter"
									:params="{type:'select',options:statusOptions}">
								</field>

								<field
									label="Filter by Customer"
									col-class="col-auto"
									v-model="myListCustomerFilter"
									:params="{type:'select',options:myListCustomerOptions}">
								</field>
							</div>
						</div>

						<div v-if="cacheCompileDate" class="p-1 mt-2">
							This list is current as of {{cacheAgeMinutes}} minutes ago ({{moment.utc(cacheCompileDate).local().format("HH:mm")}}). <a href="#" v-on:click.prevent="pullFreshServicesList">Pull Fresh List</a>
						</div>

						<div v-if="viewType == 'cards' && !calendarView">

							<div class="d-flex flex-row align-items-center mb-2">
								<button v-if="!calendarView"
									:disabled="isFilterButtonDisabled"
									class="btn btn-light filter-button mr-1"
									v-on:click="filterButtonClick">

									<i class="fa fa-filter"></i>
									Filter
								</button>

								<div class="info-boxes">
									<info-box label="Service Jobs In Progress" :value="numServiceJobsInProgress" class="mr-1" :dark="true"></info-box>
									<info-box label="Service Jobs Found" :value="servicesCount" class="mr-1" :dark="true"></info-box>
									<info-box v-if="this.$store.serviceFilterArchiveValue == 'mine' || this.$store.serviceFilterArchiveValue == 'active'" label="Estimated Total Hours" :value="estimatedHours.toFixed(2)" class="mr-1" :dark="true"></info-box>
								</div>

								<!--<router-link v-if="getUserRoleType() == 'Admin' || hasModulePermRead('Reports') && hasModulePermRead('Services')"
									to="/reports/services" title="Service Reports" class="btn btn-light">
									<i class="fa fa-line-chart"></i>
								</router-link>-->
							</div>

							<div v-if="$store.serviceFilterArchiveValue == 'mine' && !myListFilterPanelVisible" class="p-1 mt-2">
								Filtering by {{ myListStatusFilter }}<template v-if="myListCustomerOptions.find(option => option.value == myListCustomerFilter)">, {{ myListCustomerOptions.find(option => option.value == myListCustomerFilter).text }}</template>
							</div>

							<service-card v-for="(service,index) in mutatedServices"
								:service="service"
								:show-status="myListStatusFilter != 'Dispatched'"
								:key="'card_'+index"
								v-on:click="$router.push('/service/'+service.slug+'/dashboard')">
							</service-card>
						</div>

						<table-list v-else-if="!calendarView"
							:loading="loadingServices"
							:records="mutatedServices"
							:fields="mutatedFields()"
							:mobile-breakpoint="$store.tableListMobileBreakpoint"
							record-name="Service Job"
							has-edit="/service/{?}/dashboard"
							id-field="slug"
							:hide-record-count='true'
							:clickable-row="true"
							:sortable="true"
							:total-paginated-records="servicesCount"
							edit-button-text="Open">

							<div class="d-flex flex-row align-items-center">
								<button v-if="hasModulePermRead('Services') && $store.serviceFilterArchiveValue == 'mine'"
										  :disabled="isFilterButtonDisabled"
										  class="btn btn-light filter-button mr-1"
										  v-on:click="filterButtonClick">

									<i class="fa fa-filter"></i>
									Filter
								</button>

								<div class="info-boxes">
									<info-box label="Service Jobs In Progress" :value="numServiceJobsInProgress" class="mr-1" :dark="true"></info-box>
									<info-box label="Service Jobs Found" :value="servicesCount" class="mr-1" :dark="true"></info-box>
									<info-box v-if="this.$store.serviceFilterArchiveValue == 'mine' || this.$store.serviceFilterArchiveValue == 'active'" label="Estimated Total Hours" :value="estimatedHours.toFixed(2)" class="mr-1" :dark="true"></info-box>
								</div>

								<!--<router-link v-if="getUserRoleType() == 'Admin' || hasModulePermRead('Reports') && hasModulePermRead('Services')"
									to="/reports/services" title="Service Reports" class="btn btn-light">
									<i class="fa fa-line-chart"></i>
								</router-link>-->
							</div>

							<div v-if="$store.serviceFilterArchiveValue == 'mine' && !myListFilterPanelVisible" class="p-1 mt-2">
								Filtering by {{ myListStatusFilter }}<template v-if="myListCustomerOptions.find(option => option.value == myListCustomerFilter)">, {{ myListCustomerOptions.find(option => option.value == myListCustomerFilter).text }}</template>
							</div>

						</table-list>

						<pagination :current-page="page" :pages="pages" v-on:pageChange="pageChange"></pagination>
					</div>

					<div v-if="mapExpanded" class="map-panel-column" :class="{
							'col-lg-4' : mapExpanded
						}">

						<div class="map-container" :style="{top: mapPanelTop+'px'}">
							<vue-map
								v-if="$store.company.lat && $store.company.long"
								:center="{
								lat: +$store.company.lat,
								lng: +$store.company.long
							}"
								:zoom="8"
								map-size="map-lg"
								:markers="markers">
							</vue-map>

							<div style="margin-left: 10px;">
								<field
									label="Service Locations"
									col-class="col-7"
									:float-control-right="true"
									v-model="showServicesOnMap"
									:params="{type:'btn-group',buttons:[
									{text: '',value:true,icon:'fa-eye'},
									{text: '',value:false,icon:'fa-eye-slash'}
								]}">
								</field>
							</div>

							<button v-if="mapExpanded" class="btn btn-light" v-on:click="mapExpanded = false">
								<i class="fa fa-map"></i>
								Close Map
							</button>
						</div>
					</div>
				</div>
			</div>

			<schedule-component v-else
				:filters-external='{
					mainTypes: ["service","user","equipment"],
					projectIds: [],
					serviceIds: [],
					equipmentIds: [],
					userIds: []
				}'>
			</schedule-component>

		</template>

	</div>
</template>

<script>
import Toolbar from "../layout_fragments/Toolbar"
import TableList from "../components/TableList"
import Field from "../components/Field"
import FormGroup from "@/components/FormGroup"
import VueMap from "../components/VueMap"
import InfoBox from "../components/InfoBox"
import Pagination from "@/components/Pagination"
import ScheduleComponent from "@/components/schedule/ScheduleComponent"
import Alert from "@/components/Alert"
import ServiceCard from "@/components/ServiceCard"

import EventsMixins from "@/mixins/EventsMixins.js"
import ServiceMixins from "@/mixins/ServiceMixins.js"

import ProjectsToolbarControls from "./project/ProjectsToolbarControls"
import ModalDialog from "../components/ModalDialog";
import ServiceSearchBar from "@/components/super_components/ServiceSearchBar"

export default {

	name: 'Services',
	components: {
		ModalDialog,
		Toolbar,
		TableList,
		Field,
		ProjectsToolbarControls,
		VueMap,
		InfoBox,
		Pagination,
		ScheduleComponent,
		Alert,
		FormGroup,
		ServiceCard,
		ServiceSearchBar
	},
	mixins: [EventsMixins,ServiceMixins],
	props: ["hasMessagePanel"],
	data() {
		return {
			page: 1,
			pages: 0,
			openTimeLogs: [
				/*{
					User: {
						first_name: "Chad",
						last_name: "Tiffin"
					},
					Service: {
						internal_wo: "123123"
					},
					lat: 43.1,
					long: -80.6
				}*/
			],
			openWorkOrders: [
				/*{
					slug: "asasdfasdfasdfasdf",
					lat: 43.5,
					long: -80.8,
					Service: {
						slug: "asdfasdf",
						job_num: "1111"
					},
					internal_wo: 12412,
					description: "I have a leaky toilet. There's crap everywhere. I need a plumber now"
				}*/],
			mapExpanded: false,
			showServicesOnMap: false,
			loadingServices: false,
			firstLoad: true,
			mapPanelTop: 0,
			mobileBreakpoint: 1000,
			filteringFromPanel: false,
			calendarView: false,
			showSearch: true,
			archiveWarningVisible: false,
			slowSystemWarningVisible: false,
			listResponseTime: false,
			viewType: 'list',
			myListFilterPanelVisible: false,
			myListStatusFilter: 'All',
			myListCustomerFilter: null,
			cacheCompileDate: false,
			serviceRequests: {
				new: [],
				accepted: [],
				rejected: [],
			},
			requestCustomerFilter: "",
			requestStatusFilter: "new",
			requestModal: {
				isVisible: false,
				request: null,
				willAccept: false,				// Are we confirming to reject, or accept, the quote?
				rejectionText: "",
				confirmVisible: false,			// Should the confirmation message be visible
				disableConfirm: false					// Are we in the process of making the response (disables buttons to prevent spam)
			}
		}
	},
	watch: {

	},
	computed: {
		disableFilterTabs() {
			if (this.loadingServices) {
				if (!this.firstLoad) {
					return true
				}
			}
			return false
		},
		cacheAgeMinutes() {
			if (!this.cacheCompileDate)
				return 0
			else {
				return this.moment().diff(this.moment.utc(this.cacheCompileDate),'minutes')
			}
		},
		mutatedServiceRequests() {

			// What list are we using? (new, accepted, rejected, or all (which is a concat of each of the previous)
			let requestList = []
			if (this.requestStatusFilter == 'all') {
				Object.keys(this.serviceRequests).forEach(filterKey => {
					requestList.push.apply(requestList, this.serviceRequests[filterKey])
				})
			} else {
				requestList = this.serviceRequests[this.requestStatusFilter]
			}

			return requestList.map(request => {
				request.createdAt = this.formatDateTimeToLocal(request.created_at)
				request.requestedBy = request.Requester.first_name + " " + request.Requester.last_name

				let siteAddress = []
				let siteFields = ['address', 'suite', 'city', 'postal_code']
				siteFields.forEach(field => {
					if (request[field]) siteAddress.push(request[field])
				})
				request.siteAddress = siteAddress.join(', ')

				let fullAddress = []
				let addressFields = ['address', 'suite', 'city', 'province', 'country', 'postal_code']
				addressFields.forEach(field => {
					if (request[field]) fullAddress.push(request[field])
				})
				request.fullAddress = fullAddress.join(', ')

				if ('UploadFile' in request && request.UploadFile) {
					request.UploadFile.forEach(file => {
						file.src = this.apiRoot + 'resources/files/'+this.$store.sessionToken+'/'+file.filename
					})
				}

				request.status = 'New'
				if (request.is_accepted == '1')
					request.status = 'Accepted'
				else if (request.is_rejected == '1')
					request.status = 'Rejected'

				return request
			})

			.filter(request => {
				return request.requestedBy.toLowerCase().includes(this.requestCustomerFilter.toLowerCase())
			})
		},

		isFilterButtonDisabled() {
			if ((this.$store.servicePanelToggled && this.$store.serviceFilterArchiveValue != 'mine') || this.myListFilterPanelVisible)
				return true

			return false
		},
		myListCustomerOptions() {
			let customers = []

			this.$store.services.forEach(service => {
				if (!customers.find(customer => customer.value == service.customer_id)) {

					let customerName = ""

					if ("Customer" in service && service.Customer)
						customerName = service.Customer.name
					else if ("customer_name_cache" in service)
						customerName = service.customer_name_cache

					customers.push({
						text: customerName,
						value: service.customer_id
					})
				}
			})
			return customers
		},
		myServiceEvents() {
			let vm = this

			let events = []

			this.$store.services.forEach(service => {

				let assignedTo = ""
				if ("AssignedTo" in service && service.AssignedTo)
					assignedTo = ", "+service.AssignedTo.first_name+" "+service.AssignedTo.last_name

				let title = "#"+service.job_num

				if ("Customer" in service && service.Customer)
					title += ": "+service.Customer.name
				else if ("customer_name_cache" in service)
					title += ": "+service.customer_name_cache

				title += assignedTo

				let time = "[No Time]"
				if (service.due_date && service.appointment_time && vm.moment(service.due_date + " " + service.appointment_time).isValid()) 
					time = vm.moment(service.due_date + " " + service.appointment_time).format("h:mm A")
				

				let description = service.description
				if (service.address) {
					description += "<p>"+service.address

					if (service.city && service.province)
						description += "<br>"+service.city+", "+service.province

					description += "</p>"
				}

				let event = {
					date: service.due_date,
					time,
					duration: parseFloat(service.estimated_time),
					title,
					typeLabel: "service",
					description,
					link: "/service/"+service.slug+"/dashboard",
					icon: 'fa-wrench',
					color: "#ECBA00"
				}

				if (service.end_date) {

					//multi-day event, so split it

					events = events.concat(vm.splitMultiDayEvent(
						service.due_date,
						service.appointment_time,
						service.end_date,
						event
					))
				}
				else {

					events.push(event)
				}
			})

			return events
		},
		numServiceJobsInProgress() {
			let jobIds = []

			this.openTimeLogs.forEach(log => {
				if (jobIds.indexOf(log.service_id) == -1)
					jobIds.push(log.service_id)
			})

			return jobIds.length
		},
		incompleteServices() {
			if (this.$store.services) {
				return this.$store.services.filter(service => {

					if (this.dateIsEmpty(service.completed))
						return true
				})
			}
			else
				return []
		},
		estimatedHours() {
			if (this.$store.services) {
				return this.$store.services.reduce((sum,service) => {
					let estimatedTime = parseFloat(service.estimated_time)

					if (!isNaN(estimatedTime))
						return sum + parseFloat(service.estimated_time)
					else
						return sum
				},0)
			}
			else
				return 0
		},
		markers() {
			let markers = []

			if (this.openTimeLogs) {
				this.openTimeLogs.forEach(log => {

					if (log.Service) {
						markers.push({
							lat: parseFloat(log.lat),
							lng: parseFloat(log.long),
							icon: {
								anchor: {
									x: 18,
									y: 18
								},
								url:  window.apiRoot+"resources/icons/truck_36.png",
							},
							infoWindowText: "<h4><a href='/employee/"+log.User.slug+"/profile'>"+log.User.first_name+ " "+log.User.last_name+"</a></h4><p>Clocked into <a href='/service/"+log.Service.slug+"/dashboard'>Service #"+log.Service.job_num+"</a></p>"
						})
					}
				})
			}

			if (this.$store.services && this.showServicesOnMap) {
				this.$store.services.forEach(service => {

					markers.push({
						lat: parseFloat(service.lat),
						lng: parseFloat(service.long),
						icon: {
							anchor: {
								x: 18,
								y: 18
							},
							url:  window.apiRoot+"resources/icons/hardhat_36.png",
						},
						infoWindowText: "<h4><a href='/service/"+service.slug+"/dashboard'>Service #" + service.job_num + "</a></h4><p>" + service.description + "</p>"
					})
				})
			}

			return markers
		},
		filterButtonsYear() {

			let currentYear = new Date(this.moment()).getFullYear()

			let buttons = [
				{text: 'All',value: 'all'},
				{text: '< '+this.startYear,value:"pre"}
			]
			for (let y = this.startYear; y <= currentYear; y++) {
				buttons.push({text: y, value: y})
			}

			return buttons
		},
		statusOptions() {
			return this.$store.serviceStatuses.map(status => status.label)
		}
	},
	methods: {
		setMapPanelTop() {
			let vm = this
			if (window.innerWidth >= vm.mobileBreakpoint) {
				if (window.scrollY > 50)
					vm.mapPanelTop = window.scrollY - 50
				else
					vm.mapPanelTop = -50
			}
		},
		calendarViewChange(value) {
			if (!value)
				this.fetchServicesList(this.filteringFilters,true)
		},
		saveRequest(service_id=null, service_slug=null) {
			let vm = this

			let newStatusType = this.requestModal.willAccept ? 'accepted' : 'rejected'

			let requestPayload = {
				id: this.requestModal.request.id,
				is_accepted: this.requestModal.willAccept ? '1' : '0',
				is_rejected: this.requestModal.willAccept ? '0' : '1',
				service_id: service_id
			}

			if (!this.requestModal.willAccept)
				requestPayload.rejection_reason = this.requestModal.rejectionText

			// Now we respond to the request
			this.postData('ServiceRequest/save', requestPayload).then(requestResponse => {

				if (requestResponse.success) {
					let alertMessage = 'Service Request has been ' + (vm.requestModal.willAccept ? 'confirmed' : 'rejected') + ' successfully'
					vm.alertSuccess(alertMessage, false)
					vm.requestModal.isVisible = false

					// Now we move which list its in
					let oldList = vm.serviceRequests[vm.requestModal.request.status.toLowerCase()]
					let newList = vm.serviceRequests[newStatusType]

					// Remove from old list
					let removeIndex = oldList.findIndex(request => request.id == requestResponse.record_id)
					oldList.splice(removeIndex, 1)

					// Add to new list
					newList.push(vm.requestModal.request)

					// Remember to sync up the request now that we've changed it
					vm.requestModal.request.is_accepted = requestPayload.is_accepted
					vm.requestModal.request.is_rejected = requestPayload.is_rejected
					vm.requestModal.request.service_id = requestPayload.service_id

					// Now we route to the new service if it exists
					if (vm.requestModal.willAccept && service_slug)
						vm.$router.push("/service/" + service_slug + "/details")

				}
			})
		},

		createService(customer_id) {
			let vm = this

			let payload = {
				customer_id: customer_id,
				date_landed: this.moment().format('YYYY-MM-DD'),
				check_in_tolerance: 200,
				is_emergency: 0,
				is_skeleton: 1
			}

			let copyFields = ['description', 'address', 'suite', 'city', 'province', 'country', 'postal_code']
			copyFields.forEach(field => payload[field] = this.requestModal.request[field])

			// Create service using contact info given in request (might be different from user contact info)
			this.postData('Service/save', payload).then(serviceResponse => {
				if (!serviceResponse.success) {
					vm.alertErrors(serviceResponse.errors)
					return
				}

				vm.saveRequest(serviceResponse.record_id, serviceResponse.slug)

			})
		},

		createContact(user_id) {
			// We do this if no contact with a matching email or user_id is found when finalizing the service request

			let vm = this

			let userPayload = {
				fields: ['email', 'first_name', 'last_name', 'phone', 'address', 'suite', 'city', 'province', 'country', 'postal_code']
			}

			// Create contact using user name, email, and contact info
			this.getJSON('User/find/'+user_id, userPayload).then(uresponse => {

				// Next, create the new customer contact
				let contactPayload = {
					name: uresponse.data.first_name + " " + uresponse.data.last_name,
					user_id: user_id,
					is_customer: 1,
				}

				let contactFields = ['email', 'phone', 'address', 'suite', 'city', 'province', 'country', 'postal_code']
				contactFields.forEach(field => contactPayload[field] = uresponse.data[field])

				vm.postData('Contact/save', contactPayload).then(cresponse => {

					// Now, we can finally create the service if we're accepting the request
					vm.createService(cresponse.record_id)
				})

			})
		},

		respondRequest() {
			let vm = this

			this.requestModal.disableConfirm = true

			// Are we rejecting the service request? If so, save and close
			if (!this.requestModal.willAccept) {
				this.saveRequest()
				return
			}

			let contactPayload = {
				fields: ['id', 'user_id', 'email'],
				filters: [
					['user_id', this.requestModal.request.requester_id],
					['email', this.requestModal.request.Requester.email, 'or']
				]
			}

			// First get the id of the customer contact (requester).  If one doesn't exist, create it
			this.getJSON('Contact/get', contactPayload).then(response => {

				// No matching contacts? Create a contact
				if (!response.data.length)
					vm.createContact(vm.requestModal.request.requester_id)
				// Otherwise just jump straight to the service using the first result
				else
					vm.createService(response.data[0].id)

			})

		},

		// Is the user wanting to accept the request?
		toggleConfirmRequest(toggleStatus, willAccept) {
			this.requestModal.willAccept = willAccept
			this.requestModal.confirmVisible = toggleStatus
		},

		openRequestModal(request) {
			this.requestModal.request = request
			this.requestModal.isVisible = true
			this.requestModal.disableConfirm = false
			this.toggleConfirmRequest(false, false)
		},
		actionMenuClick(button) {
			if (button.text == "Search")
				this.showSearch = true
		},
		clearSearch() {
			this.fetchServicesList(this.filteringFilters,true)
		},
		filterButtonClick() {
			if (this.$store.serviceFilterArchiveValue == 'mine')
				this.myListFilterPanelVisible = true

			else
				this.$store.servicePanelToggled = true
		},
		clearFilters() {
			this.$store.serviceFilteringValues.category_id = null
			this.$store.serviceFilteringValues.customer_id = null
			this.$store.serviceFilteringValues.assigned_to = null
			this.$store.serviceFilteringValues.jobRangeEnd = null
			this.$store.serviceFilteringValues.jobRangeStart = null

			this.filteringFromPanel = false

			this.fetchServicesList(this.filteringFilters,true)
		},
		pageChange(page) {
			this.page = page

			if (this.filteringFromPanel) {
				this.filterServices(true)
			}
			else
				this.fetchServicesList(this.filteringFilters,true)
		},
		searchServices(terms) {
			this.$store.serviceFilterYearValue = "all";
			this.$store.serviceFilterArchiveValue = "all"

			let filters = [
				["job_name",terms,"and","like"],
				["job_num",terms,"or","like"],
				['customer_po',terms,'or','like'],
				["city",terms,"or","like"],
				["address",terms,"or","like"],
				["postal_code",terms,"or","like"]
			]

			this.fetchServicesList(filters,true)
		},
		newService(isQuote) {
			if (!isQuote)
				this.$router.push("/service/new/details")
			else
				this.$router.push("/service/new-quote/details")
		},
		filterServices(spinner) {
			let vm = this

			return new Promise((resolve,reject) => {

				this.$nextTick(() => {

					let filters = []

					vm.filteringFromPanel = true

					if (vm.$store.serviceFilteringValues.customer_id)
						filters.push(["customer_id",vm.$store.serviceFilteringValues.customer_id])

					if (vm.$store.serviceFilteringValues.assigned_to)
						filters.push(["assigned_to",vm.$store.serviceFilteringValues.assigned_to])

					if (vm.$store.serviceFilteringValues.category_id)
						filters.push(["category_id",vm.$store.serviceFilteringValues.category_id])

					if (vm.$store.serviceFilteringValues.revenue_code_id)
						filters.push(["revenue_code_id",vm.$store.serviceFilteringValues.revenue_code_id])

					if (vm.$store.serviceFilteringValues.jobRangeStart)
						filters.push(["job_num >=",vm.$store.serviceFilteringValues.jobRangeStart])

					if (vm.$store.serviceFilteringValues.jobRangeEnd)
						filters.push(["job_num <=",vm.$store.serviceFilteringValues.jobRangeEnd])

					if (Array.isArray(vm.filteringFilters)) {
						if (vm.$store.serviceFilterArchiveValue == 'draft') {

							//draft filter contains an 'or' so we need to push these filters to front and back of array
							filters = [
								...filters,
								...vm.filteringFilters,
								...filters
							]
						}
						else
							filters = filters.concat(vm.filteringFilters)
					}
					else {
						filters = {
							a: filters.concat(vm.filteringFilters.a),
							b: filters.concat(vm.filteringFilters.b)
						}
					}

					vm.fetchServicesList(filters,spinner).then(response => {
						resolve(response)
					})
				})

			})
		},
		statusToggled() {
			let vm = this

			/*vm.$store.serviceFilteringValues = {
				assigned_to: null,
				customer_id: null,
				category_id: null
			}*/

			this.myListFilterPanelVisible = false

			vm.$nextTick(() => {
				vm.page = 1

				if (vm.$store.serviceFilterArchiveValue == 'mine')
					vm.$store.servicePanelToggled = false

				if (vm.$store.serviceFilterArchiveValue == 'requests') {
					this.fetchServiceRequests(vm.requestStatusFilter)
				}
				else
					vm.filterServices(true)
			})
		},
		fetchServiceRequests(statusType) {
			let vm = this

			// Fix history (this is handled through fetchServicesList() under normal cicumstances)
			window.history.replaceState({},"","/services/"+this.$store.serviceFilterArchiveValue)

			// Fetch each kind if all is selected
			if (statusType == 'all') {
				this.fetchServiceRequests('new')
				this.fetchServiceRequests('accepted')
				this.fetchServiceRequests('rejected')
				return
			}

			// Already have it? Don't fetch
			else if (this.serviceRequests[statusType].length)
				return

			let payload = {
				filters: [
					['is_rejected', statusType == 'rejected' ? '1' : '0'],
					['is_accepted', statusType == 'accepted' ? '1' : '0'],
				],
				include: [
					{ model: 'User', fields: ['first_name', 'last_name', 'email'] },
					{ model: 'UploadFile', fields: ['original_filename', 'filename'] }
				]
			}

			if (statusType == 'all')
				payload.filters = []
			else if (statusType == 'accepted')
				payload.include.push({ model: 'Service', fields: ['slug'] })

			this.getJSON('ServiceRequest/get', payload).then(response => {
				vm.serviceRequests[statusType] = response.data
			})
		},
		pullFreshServicesList() {
			this.fetchServicesList(this.filteringFilters,true,true)
		},
		fetchServicesList(filters,cycleSpinner,bustCache) {
			let vm = this

			if (cycleSpinner) {
				this.spinner(true)
			}

			this.loadingServices = true

			window.history.replaceState({},"","/services/"+this.$store.serviceFilterArchiveValue) //use native pushState instead of vue-router method so the component doesn't re-load

			let include = [
				{model:"User",fields:["id","slug","first_name","last_name"]/*,omit: ["User"]*/},
				{model: "ContactLocation",fields: ["id","slug","location_name"]},
				{model: "JobPersonnelRole", fields: ["id","slug","abbreviation","title","user_id","personnel_role_id","display_on_listings"]},
				{
					model: "ScheduleEvent", 
					filters: [
						["start_time >=",vm.moment.utc().format("YYYY-MM-DD")]
					],
					limit: 1,
					orders: [["start_time","ASC"]]
				}
			]

			/*
			if (this.$store.serviceFilterArchiveValue == "reviewed" || this.$store.serviceFilterArchiveValue == "completed")
				//include Time Logs so we can filter by them
				include.push({model: "TimeLog",fields:["id","slug","reviewed_by","submitted_by"]})
			*/

			if (this.$store.serviceFilterArchiveValue == 'quote')
				include.push({model: "ServiceInvoice",fields: ["id","slug","quote_status","is_quote","finalized"],omit: ["BatchInvoice"]})

			this.$store.paginationStates[this.$route.path] = this.page

			let params = {
				include,
				filters,
				orders: []
			}

			if (this.$store.serviceFilterArchiveValue == 'all') {
				params.orders = [
					["is_emergency","DESC"],
					["job_num","DESC"],
					['due_date',"DESC"],
					['appointment_time',"DESC"]
				]
			}
			else {
				params.orders = [
					["is_emergency","DESC"],
					['due_date',"DESC"],
					['appointment_time',"DESC"],
					["job_num","DESC"]
				]
			}

			let promises = []

			params.acceptCache = true
			if (bustCache) 
				delete params.acceptCache

			if (this.$store.serviceFilterArchiveValue == 'mine') {
				delete params.filters
				params.page = this.page

				promises.push(this.getJSON("Service/my-list",params,true))
			}
			else {
				if (Array.isArray(filters)) {
					//single fetch
					params.page = this.page
					promises.push(this.getJSON("Service/get",params,true))
				}
				else {
					//multiple fetches
					params.filters = filters.a
					promises.push(this.getJSON("Service/get",params,true))
					params.filters = filters.b
					promises.push(this.getJSON("Service/get",params,true))
				}

				if (this.$store.serviceFilterArchiveValue != "completed" && this.$store.serviceFilterArchiveValue != "reviewed" && Array.isArray(filters))
					params.page = this.page
			}

			return new Promise((resolve,reject) => {

				Promise.all(promises).then(responses => {

					if (vm.firstLoad) 
						vm.firstLoad = false

					if (cycleSpinner) 
						vm.spinner(false)

					vm.loadingServices = false

					if (responses.length > 1) {
						//multiple fetches, we need to merge them
						let services = []
						if (responses[0].success)
							services = responses[0].data
						if (responses[1].success) {
							services = [
								...services,
								...responses[1].data
							]
						}

						//remove duplicates
						let cleanedServices = []
						services.forEach(service => {
							if (!cleanedServices.find(cleanedService => cleanedService.id == service.id))
								cleanedServices.push(service)
						})

						vm.$store.services = cleanedServices
						vm.pages = 1

						vm.listResponseTime = responses[0].requestLength

						if ("meta" in responses[0] && "meta" in responses[1])
							vm.servicesCount = responses[0].meta.num_results + responses[1].meta.num_results
						else
							vm.servicesCount = responses[0].data.length + responses[1].data.length
					}
					else {
						if (responses[0].success) {
							if ("meta" in responses[0]) {
								vm.pages = responses[0].meta.num_pages
								vm.servicesCount = responses[0].meta.num_results
							}
							else {
								vm.pages = 1
								vm.servicesCount = responses[0].data.length
							}
							vm.$store.services = responses[0].data

							vm.listResponseTime = responses[0].requestLength
						}
					}

					if (vm.servicesCount > 50 && (vm.$store.serviceFilterArchiveValue == 'invoiced' || vm.$store.serviceFilterArchiveValue == 'mine'))
						vm.archiveWarningVisible = true
					else
						vm.archiveWarningVisible = false

					if (vm.servicesCount > 200 && vm.listResponseTime > 30 && this.$store.serviceFilterArchiveValue == 'mine') {
						vm.archiveWarningVisible = false
						vm.slowSystemWarningVisible = true
					}
					else
						vm.slowSystemWarningVisible = false

					if ("cacheCompiledAt" in responses[0])
						vm.cacheCompileDate = responses[0].cacheCompiledAt
					else
						vm.cacheCompileDate = false

					resolve(responses)
				})
			})
		},
		fetchData(filters) {
			let vm = this

			this.spinner(true)

			let timeLogFilters = JSON.stringify([
				["service_id !=",0]
			])

			let timeLogInclude = JSON.stringify(["Service","User"])

			let promises = [
				//this.getJSON("JobPersonnelRole/get"),
				this.filterServices(false),
				this.getJSON("OpenTimeLog/get",{include:timeLogInclude,filters:timeLogFilters}),
				this.getJSON("Category/get",{fields: ["id","slug","name"]}),
				this.fetchServiceStatuses()
			]

			if (this.$store.jobPersonnelRoles.length == 0)
				promises.push(this.fetchJobPersonnelRoles())

			Promise.all(promises).then(responses=>{

				vm.$store.categories = responses[2].data
				vm.openTimeLogs = responses[1].data

				vm.spinner(false)
			})

		}
	},
	created() {

		this.setMapPanelTop()

		if ("query" in this.$route) {
			this.$store.serviceFilteringValues = this.cloneObj(this.$route.query)
			this.$store.servicePanelToggled = true
		}

		if ("filter" in this.$route.params) {
			this.$store.serviceFilterArchiveValue = this.$route.params.filter
			if (this.$route.params.filter == 'requests')
				this.fetchServiceRequests(this.requestStatusFilter)
			else
				this.fetchData(this.filteringFilters)
		} else {
			if (this.hasModulePermRead('Services'))
				this.$store.serviceFilterArchiveValue = "all"
			else
				this.$store.serviceFilterArchiveValue = "mine"
			
			this.fetchData(this.filteringFilters)
		}

		this.$store.servicePanelToggled = false

		if (this.$route.path in this.$store.paginationStates)
			this.page = this.$store.paginationStates[this.$route.path]

		this.$store.lastRoute = this.$route.path

		if (window.innerWidth < this.mobileBreakpoint)
			this.showSearch = false
		else
			this.showSearch = true

		let vm = this

		if (window.innerWidth < vm.mobileBreakpoint) {
			//vm.showSearch = false
			vm.mapExpanded = false //map gets bumped down, so technically speaking its not expanded anymore
			vm.viewType = 'cards'
		}
		else
			vm.viewType = 'list'

		window.addEventListener("resize",event => {
			if (window.innerWidth < vm.mobileBreakpoint) {
				//vm.showSearch = false
				vm.mapExpanded = false //map gets bumped down, so technically speaking its not expanded anymore
				vm.viewType = 'cards'
			}
			else
				vm.viewType = 'list'

			vm.setMapPanelTop()
		})

		window.addEventListener("scroll",event => {
			vm.setMapPanelTop()
		})
	},
	destroyed() {
		window.removeEventListener("scroll",() => {})
		window.removeEventListener("resize",() => {})
	}

}
</script>

<style type="text/css">
.inline-field {
	display: inline-block;
}

.filter-controls {
	margin-bottom: 10px;
}

.info-boxes {
	display: flex;
}

.info-boxes div {
	font-size: 18pt;
	text-align: center;
}

.map-panel {
	border-left: 2px solid #EAE9E7;
	padding-left: 0;
	padding-bottom: 0;
	padding-right: 0;
	position: relative;
	margin-left: 10px;
	transition: margin 0.5s;
	height: 100%;
}

.main-panel-container {
	display: flex;
	flex-direction: row;
}

.main-expanded {
	width: 100%;
}

.main-full {
	width: 100%;
}

.message-panel-open .main-expanded {
	width: 100%;
}

.main-shrunk {
	width: calc(100% - 610px);
}

.panel-shrunk {
	margin-left: 20px;
}

.main-container .filter-button {
	display: inline-block;
}

.map-container {
	position: absolute;
	width:calc(100% - 30px);
}

.toolbar .filter-button {
	display: none;
}

.filter-tabs {
	display: block;
}

.filter-select {
	display: none;
}

@media (max-width: 1000px) {

	.container-fluid {
		/*overflow-x: hidden!important;*/
	}

	.main-panel-container {
		flex-direction: column;
	}

	.map-container {
		position: static;
		width: 100%;
	}
}

@media (max-width: 600px) {
	.info-boxes {
		display: none;
	}

	.calendar-wrapper {
		margin-left: -10px;
		margin-right: -10px;
	}

	.filter-tabs {
		display: none;
	}

	.filter-select {
		display: block;
	}
}

@media (max-width: 400px) {

	.toolbar .filter-button {
		display: inline-block;
	}
}
</style>